<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- foto, nome e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <!-- foto -->
          <img
            class="w-10 h-10 rounded-full"
            :src="
              !row['avatar']
                ? defaultImg
                : row['avatar']
            "
            :alt="row['name'] ?? 'nome do assinante'"
          />

          <!-- nome e função -->
          <div class="ps-3">
            <div class="text-base font-semibold">
              {{ row["name"] }}
            </div>
          </div>
        </th>

        <!-- email -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div class="text-base font-semibold">
            {{ row["email"] }}
          </div>
        </td>

        <!-- eventos -->
        <td class="px-1 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full me-2"
            ></div>
            {{ row["my_events"].length }}
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">
            <!-- Ver documento -->
            <a
              title="Detalhes do relato"
              class="text-green-600 mr-1 cursor-pointer"
              @click="openModal(data[index])"
            >
              <component :is="PhGearSix" class="h-7 w-7 md:h-6 md:w-6" />
            </a>

            <!-- Remover documento -->
            <a
              title="Desativar assinante"
              class="text-red-600 mr-1 hover:underline cursor-pointer"
              @click="deleteDoc(row['id'])"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { dataAso } from '@/modules/asos/store'
import { PhGearSix, PhTrash } from '@phosphor-icons/vue'
import { defineProps } from 'vue'

const imageServe = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const defaultImg = require('@/assets/logo/icon.png')
const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

function deleteDoc (id) {
  emit('delete', id)
}

function openModal (data) {
  dataAso.dispatch('setModalActive', data)
}

</script>
